import React from 'react';
import PropTypes from 'prop-types';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import Alert from '../../../../common/informative/Alert';
import { PREVENTIVE_TASK_WITHOUT_SUBTASKS } from '../../../../../config/messages';

const PreventiveTaskChecklistResource = ({ checklistItems }) => {
  if (!Array.isArray(checklistItems) || !checklistItems.length) {
    return <Alert message={PREVENTIVE_TASK_WITHOUT_SUBTASKS} type="warning" />;
  }

  return (
    <>
      {checklistItems.map((item, index) => (
        <ResourceProperty
          key={item.id || `${item.name}-${index}`}
          label={`Subtarea ${index + 1}:`}
        >
          {item.name || '-'}
        </ResourceProperty>
      ))}
    </>
  );
};

PreventiveTaskChecklistResource.propTypes = {
  checklistItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      preventiveTaskId: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string,
      createDate: PropTypes.number,
      lastUpdate: PropTypes.number,
    }),
  ),
};

PreventiveTaskChecklistResource.defaultProps = {
  checklistItems: [],
};

export default PreventiveTaskChecklistResource;
